import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Updates(): ReactElement {
  return (
    <PageShell
      title="Updates"
      intro="Was ist neu in Saldify? Hier halten wir Sie über Verbesserungen und neue Funktionen auf dem Laufenden."
    >
      <PageSection title="Kontinuierliche Weiterentwicklung">
        <p>
          Saldify wird laufend weiterentwickelt. Neue Funktionen, Verbesserungen und
          Fehlerbehebungen spielen wir regelmäßig ein – ohne dass Sie etwas
          installieren müssen.
        </p>
      </PageSection>

      <PageSection title="Auf dem Laufenden bleiben">
        <p>
          Eine detaillierte Änderungshistorie ist in Vorbereitung. Bis dahin
          informieren wir über größere Neuerungen per Newsletter (Anmeldung im
          Seitenfuß).
        </p>
      </PageSection>
    </PageShell>
  );
}
